import React, { Component } from 'react';
import './SectionHeader.css';
import ButtonToTop from '../ButtonToTop/ButtonToTop';

class SectionHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }

    static propTypes =  {
        onChange:   React.PropTypes.func
    }

    handleClick = (e) =>  {
        if (typeof this.props.onChange === 'function') {
            //this.props.onChange();
        }
    }


  render() {

    return (
        <div className="SectionHeader">
            <h2>{this.props.title}</h2>
            <ButtonToTop></ButtonToTop>
        </div>
    );
  }
}

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/SectionHeader/SectionHeader.js